import { useRouter } from 'next/navigation'
import { useLocale } from 'next-intl'
import { getFormattedDate } from '@/src/utils/date'
import dayjs from 'dayjs'

/**
 * Handles Book Now button click for Top Cities section.
 * Uses airport codes from JSON when provided (no API call) to improve INP.
 * Falls back to flights page if codes are missing.
 */
export const useHandleTopCityBookNow = () => {
    const router = useRouter()
    const locale = useLocale()

    const handleBookNow = (
        originCity: string,
        destinationCity: string,
        fromCode?: string,
        toCode?: string
    ) => {
        // Use codes from JSON when available - no API call needed
        const originAirportCode = fromCode || ''
        const destinationAirportCode = toCode || ''

        if (!originAirportCode || !destinationAirportCode) {
            // Fallback: navigate to flights page if codes not in JSON
            router.push(`/${locale}/flights`)
            return
        }

        // Calculate date 7 days from today
        const departDate = dayjs().add(7, 'day')
        const formattedDepartDate = getFormattedDate(departDate.toDate(), 'DD/MM/YYYY')

        // Build query parameters
        const queryParams = new URLSearchParams()
        queryParams.set('from', originAirportCode)
        queryParams.set('to', destinationAirportCode)
        queryParams.set('origin', originCity)
        queryParams.set('destination', destinationCity)
        queryParams.set('adults', '1')
        queryParams.set('childs', '0')
        queryParams.set('infants', '0')
        queryParams.set('class', 'Economy')
        queryParams.set('depart_date', formattedDepartDate)
        queryParams.set('return_date', '') // One-way trip

        // Generate SRP URL
        const url = `/${locale}/flights/results?${queryParams.toString()}`

        // Navigate to SRP
        router.push(url)
    }

    return { handleBookNow }
}
